import { Component, h, Prop, Element } from '@stencil/core';

declare const assetPath;

/**
 * This component specifically handles videos with an optional lightbox
 */
@Component({
	tag: 'kdx-video-embed',
	styleUrl: 'kdx-video-embed.scss',
	shadow: false,
})
export class StVideoEmbed {

	@Element() root: HTMLElement;

	/**
	 * Source for the placeholder image
	 */
	@Prop() imgSrc: string;

	/**
	 * Alt text for the placeholder image
	 */
	@Prop() imgAlt: string;

	/**
	 * Alt text for the video embed button
	 */
	@Prop() btnAltText: string = "Click to see video";

	/**
	 * Pass it should load modal
	 */
	@Prop() noModal: boolean;

	componentDidLoad() {
		if (!this.noModal) {
			const playBtn: HTMLElement = this.root.querySelector('.video-embed-btn');
			const modal: HTMLElement = this.root.querySelector('.video-embed-content');
			const overlay: HTMLElement = modal.querySelector('.overlay');
			const closeBtns: NodeListOf<HTMLElement> = modal.querySelectorAll('.close-frame');
			const frame: any = modal.querySelector('iframe');
			const docBody: HTMLElement = document.querySelector('body');

			// Opens lightbox
			playBtn.onclick = (e) => {
				e.preventDefault();
				modal.classList.add('open');
				docBody.classList.add('lightbox-open');
				closeBtns[0].focus();
				frame.setAttribute('src', frame.getAttribute('data-src'));
			};

			// Close lightbox on overlay click
			overlay.onclick = () => {
				modal.classList.remove('open');
				docBody.classList.remove('lightbox-open');
				frame.removeAttribute('src');
			};

			// Close lightbox if any close button is clicked
			closeBtns.forEach((close) => {
				close.onclick = (e) => {
					e.preventDefault();
					modal.classList.remove('open');
					docBody.classList.remove('lightbox-open');
					frame.removeAttribute('src');
				};
			});

			// Close lightbox if escape key is pressed
			document.addEventListener('keydown', (e) => {
				// console.log(e.key);
				// console.log(e.code);
				if (modal.classList.contains('open') && (e.key === 'Escape' || e.key === 'Esc' ||e.code === 'Escape')) {
					e.preventDefault();
					modal.classList.remove('open');
					docBody.classList.remove('lightbox-open');
					frame.removeAttribute('src');
				}
			});

			// Move focus to end of lightbox if it tries to pass first focusable
			closeBtns[0].addEventListener('keydown', (e) => {
				if ((e.key === 'Tab' || e.code === 'Tab') && e.shiftKey) {
					e.preventDefault();
					closeBtns[closeBtns.length - 1].focus();
				}
			});

			// Move focus to beginning of lightbox if it tries to pass last focusable
			closeBtns[closeBtns.length - 1].addEventListener('keydown', (e) => {
				if ((e.key === 'Tab' || e.code === 'Tab') && !e.shiftKey) {
					e.preventDefault();
					closeBtns[0].focus();
				}
			});
		}
	}

	render() {
		return (
			<div class="video-embed">
				<button class="video-embed-btn" aria-label={this.btnAltText} type="button">
					<div class="img lazy-load-bg" style={{ backgroundImage: `url('${this.imgSrc}')`}} role="presentation"></div>
					<span class="play-icon">
						<kdx-lazy-img css-class="yt-play" img-src={`${assetPath}/img/video-cta-play-btn.png`} img-alt="Play video"></kdx-lazy-img>
					</span>
				</button>

				{!this.noModal && (
					<div class="video-embed-content">
					<div class="overlay"></div>
					
					<div class="video-inner">
						<div>
							<div class="modal-spinner">
								<div class="spinner-border text-light" role="status">
									<span class="visually-hidden">Loading...</span>
								</div>
							</div>
							<div class="video-frame">
								<div>
									<button class="close-frame" aria-label="Close">
										<kdx-icon icon="times" />
									</button>
								</div>
								<slot />
								<div class="d-flex justify-content-center">
									<button class="close-frame close-frame-bottom visually-hidden-focusable" aria-label="Close">
										<kdx-icon icon="times" />
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
				)}
			</div>
		);
	}

}